import { render, staticRenderFns } from "./ExcelExport.vue?vue&type=template&id=2b631c9c"
import script from "./ExcelExport.vue?vue&type=script&lang=js"
export * from "./ExcelExport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports